export enum SwapTab {
  Swap = 'swap',
  Stock = 'stock',
  Limit = 'limit',
  Send = 'send',
  Buy = 'buy',
  Sell = 'sell'
}
